import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_50: FaireProductEntity = {
  token: "catalog_prod_prod-50",
  type: "product",
  name: "Linen Table Runner - Natural",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop",
  priceDollars: 43.35,
  msrpDollars: 108.38,
  sku: "JA0050",
  caseSize: 6,
  material: "Glass",
  collectionToken: "col_japandi",
  isNew: true,
  isBestseller: true,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 33,
  description: "Beautiful Japandi piece perfect for any home.",
  categoryTokens: ["catalog_cat_wall-decor"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
